import UIButton from './components/UIButton';

export default abstract class BaseButton extends Phaser.GameObjects.Container {
  get UIButton(): UIButton {
    return UIButton.getComponent(this);
  }

  public setButtonState(state: boolean) {
    this.UIButton.setState(state);
  }

  public ignoreCamera(camera: Phaser.Cameras.Scene2D.Camera) {
    this.UIButton.ignoreCamera(camera);
  }
}
